import { useMemo } from "react";

import type { TriggerFn } from "../../../../vendor/LexicalTriggerMenuPlugin";

export const PUNCTUATION = ",\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'\"~=<>:;";

const validChars = "[^" + PUNCTUATION + "\\s]*";

type MatchProps = {
    prioritizedTriggers: Array<{ openingTag: string; closingTag: string }>;
};

export function useTypeaheadTriggerMatch({ prioritizedTriggers }: MatchProps): {
    triggerCallbacks: Array<TriggerFn>;
} {
    const triggerCallbacks = useMemo(() => {
        return prioritizedTriggers.map(({ openingTag, closingTag }) => {
            const TypeaheadTriggerRegex = new RegExp("(^|\\s|\\(|)(" + openingTag + "(" + validChars + ")" + ")$");
            return (text: string) => {
                const match = TypeaheadTriggerRegex.exec(text);
                if (match !== null) {
                    const maybeLeadingWhitespace = match[1];
                    const matchingString = match[3];
                    const replace = match[2];
                    return {
                        leadOffset: match.index + maybeLeadingWhitespace.length,
                        replaceableString: replace,
                        matchingString,
                        openingTag,
                        closingTag,
                    };
                }
            };
        });
    }, [prioritizedTriggers]);

    return { triggerCallbacks };
}
